import React from 'react';
import { useAuth } from '@clerk/clerk-react';
import LoadingSpinner from '../ui/LoadingSpinner';

const AuthWrapper = ({ children }) => {
  const { isLoaded } = useAuth();

  if (!isLoaded) {
    return <LoadingSpinner message="Initializing..." />;
  }

  // Always render children - no authentication required
  return children;
};

export default AuthWrapper;